import { ImageOff, Loader2 } from 'lucide-react';
import { cn } from '@/helpers/shadcn';

import { useZealScreenshot } from '@/data/zealTask';

const ScreenshotImage = ({ screenshot, className }) => {
  const image = useZealScreenshot(screenshot.object);

  if (image.error) {
    return (
      <div className={cn('flex items-center justify-center rounded border bg-muted text-muted-foreground', className)} title={`Could not load ${screenshot.name}`}>
        <ImageOff className="h-4 w-4" />
      </div>
    );
  }

  if (!image.data) {
    return (
      <div className={cn('flex items-center justify-center rounded border bg-muted', className)}>
        <Loader2 className="h-4 w-4 animate-spin" />
      </div>
    );
  }

  return <img src={image.data} alt={screenshot.name} className={cn('rounded border object-cover', className)} />;
};

export default ScreenshotImage;
